/**
 * O catálogo de classificação institucional para as telas de órgãos e entidades.
 *
 * Mora num módulo próprio porque três telas o usam — a lista, o modal de
 * cadastro e a ficha — e a cópia era exatamente o defeito que a feature 009
 * corrige: "Administração direta" virou sinônimo de prefeitura em três lugares
 * ao mesmo tempo justamente por haver três listas.
 *
 * A fonte continua sendo `@atlas/types`: aqui só se traduz o valor no par
 * `{ value, label }` que os `SelectField` consomem.
 */
import {
  CLASSIFICACOES_ADM,
  ESFERAS,
  PODERES,
  ROTULOS,
  TIPOS_ORGANIZACAO,
  type ClassificacaoAdm,
  type Esfera,
  type Poder,
  type TipoOrganizacao,
} from "@atlas/types";

export const TIPO_ORGANIZACAO_OPCOES = TIPOS_ORGANIZACAO.map((v) => ({ value: v, label: ROTULOS.tipo[v] }));
export const ESFERA_OPCOES = ESFERAS.map((v) => ({ value: v, label: ROTULOS.esfera[v] }));
export const PODER_OPCOES = PODERES.map((v) => ({ value: v, label: ROTULOS.poder[v] }));
export const CLASSIFICACAO_OPCOES = CLASSIFICACOES_ADM.map((v) => ({ value: v, label: ROTULOS.classificacaoAdm[v] }));

/** Tabela D3 da spec, espelhada para a tela preencher sozinha ao trocar o tipo.
 *  `esfera: null` = o tipo não a determina (autarquia existe nas três). */
export const SUGESTAO_POR_TIPO: Record<TipoOrganizacao, { esfera: Esfera | null; poder: Poder; classificacaoAdm: ClassificacaoAdm }> = {
  prefeitura: { esfera: "municipal", poder: "executivo", classificacaoAdm: "direta" },
  camara_municipal: { esfera: "municipal", poder: "legislativo", classificacaoAdm: "direta" },
  governo_estadual: { esfera: "estadual", poder: "executivo", classificacaoAdm: "direta" },
  assembleia_legislativa: { esfera: "estadual", poder: "legislativo", classificacaoAdm: "direta" },
  tribunal: { esfera: "estadual", poder: "judiciario", classificacaoAdm: "direta" },
  ministerio_publico: { esfera: "estadual", poder: "autonomo", classificacaoAdm: "direta" },
  tribunal_de_contas: { esfera: "estadual", poder: "autonomo", classificacaoAdm: "direta" },
  defensoria_publica: { esfera: "estadual", poder: "autonomo", classificacaoAdm: "direta" },
  secretaria: { esfera: null, poder: "executivo", classificacaoAdm: "direta" },
  autarquia: { esfera: null, poder: "executivo", classificacaoAdm: "indireta" },
  fundacao: { esfera: null, poder: "executivo", classificacaoAdm: "indireta" },
  fundo: { esfera: null, poder: "executivo", classificacaoAdm: "direta" },
  instituto_previdencia: { esfera: null, poder: "executivo", classificacaoAdm: "indireta" },
  empresa_publica: { esfera: null, poder: "executivo", classificacaoAdm: "indireta" },
  consorcio_publico: { esfera: null, poder: "outro", classificacaoAdm: "nao_se_aplica" },
  outra: { esfera: null, poder: "outro", classificacaoAdm: "nao_se_aplica" },
};

/** O rótulo do tipo, com o default de quem foi cadastrado antes da 009. */
export const rotuloTipo = (t: TipoOrganizacao | undefined): string => ROTULOS.tipo[t ?? "prefeitura"];
